module.exports = __webpack_public_path__ + "img/shopify.046ae260.jpg";